<script setup lang="ts">
import { useRelatiesGetKredietstatus } from '@services/crm-public/orval-api/relaties-api/relaties-api';
import VInfoBox from '@shared/component/VInfoBox/VInfoBox.vue';
import VPageContainer from '@shared/layout/VPageContainer/VPageContainer.vue';
import { toRefs } from 'vue';

import RelatiegegevensEmbed from '../RelatiegegevensEmbed.vue';

const props = defineProps<{
  relatienummer: number;
}>();
const { relatienummer } = toRefs(props);

const { isError, data: kredietstatus } = useRelatiesGetKredietstatus(relatienummer, {
  query: { select: (r) => r.result },
});
</script>

<template>
  <VPageContainer container-size="sm" gap="xs" title="Incasso">
    <VInfoBox
      :type="kredietstatus.status === 'Rood' ? 'danger' : 'warning'"
      v-if="!isError && kredietstatus && kredietstatus.melding"
    >
      {{ kredietstatus.melding }}
    </VInfoBox>
    <RelatiegegevensEmbed :relatienummer="relatienummer" tab="incasso" />
  </VPageContainer>
</template>
